import { ChangeDetectorRef, Component, Input } from '@angular/core';

import { BppProvidersService } from '../../../bpp/services/bppProviders/bpp-providers.service';
import { ISRMSelectedQuestionAndAnswer } from '../../../core/models/srm.model';
import { BonusSuppressionService } from '../../../core/services/BonusSuppression/bonus-suppression.service';
import { CmsService } from '../../../core/services/cms/cms.service';
import { CommandService } from '../../../core/services/communication/command/command.service';
import { PubSubService } from '../../../core/services/communication/pubsub/pubsub.service';
import { FiltersService } from '../../../core/services/filters/filters.service';
import { FreeBetsService } from '../../../core/services/freeBets/free-bets.service';
import { GtmService } from '../../../core/services/gtm/gtm.service';
import { LocaleService } from '../../../core/services/locale/locale.service';
import { SessionStorageService } from '../../../core/services/storage/session-storage.service';
import { StorageService } from '../../../core/services/storage/storage.service';
import { TimeService } from '../../../core/services/time/time.service';
import { UserService } from '../../../core/services/user/user.service';
import { WindowRefService } from '../../../core/services/windowRef/window-ref.service';
import { ServiceClosureService } from '../../../lazy-modules/serviceClosure/service-closure.service';
import { QuickbetSelectionComponent } from '../../../quickbet/components/quickbetSelection/quickbet-selection.component';
import { QuickbetDepositService } from '../../../quickbet/services/quickbetDepositService/quickbet-deposit.service';
import { QuickbetNotificationService } from '../../../quickbet/services/quickbetNotificationService/quickbet-notification.service';
import { QuickbetUpdateService } from '../../../quickbet/services/quickbetUpdateService/quickbet-update.service';
import { SRMQuickbetService } from '../../services/srm-quickbet.service';

@Component({
    selector: 'srm-quickbet-selection',
    templateUrl: 'srm-quickbet-selection.component.html',
    styleUrls: ['../../../quickbet/components/quickbetSelection/quickbet-selection.component.scss', 'srm-quickbet-selection.component.scss'],
    standalone: false,
})
export class SrmQuickbetSelectionComponent extends QuickbetSelectionComponent {
    @Input() isSRMBet: boolean;
    @Input() selectedQuestionAndAnswers?: ISRMSelectedQuestionAndAnswer[];
    @Input() srmOdds: string;

    constructor(
        pubsub: PubSubService,
        user: UserService,
        locale: LocaleService,
        filtersService: FiltersService,
        quickbetDepositService: QuickbetDepositService,
        srmQuickbetService: SRMQuickbetService,
        quickbetUpdateService: QuickbetUpdateService,
        freeBetsFactory: FreeBetsService,
        quickbetNotificationService: QuickbetNotificationService,
        commandService: CommandService,
        cmsService: CmsService,
        gtmService: GtmService,
        cdr: ChangeDetectorRef,
        windowRef: WindowRefService,
        timeService: TimeService,
        bppProviderService: BppProvidersService,
        serviceClosureService: ServiceClosureService,
        sessionStorageService: SessionStorageService,
        storageService: StorageService,
        protected override bonusSuppressionService: BonusSuppressionService,
    ) {
        super(
            pubsub,
            user,
            locale,
            filtersService,
            quickbetDepositService,
            srmQuickbetService,
            quickbetUpdateService,
            freeBetsFactory,
            quickbetNotificationService,
            commandService,
            cmsService,
            gtmService,
            cdr,
            windowRef,
            timeService,
            bppProviderService,
            serviceClosureService,
            sessionStorageService,
            storageService,
            bonusSuppressionService,
        );
    }
}
